export const signInTypes = {
    SIGN_IN_REQUEST: 'USER_SIGN_IN_REQUEST',
    SIGN_IN_SUCCESS: 'USER_SIGN_IN_SUCCESS',
    SIGN_IN_FAILURE: 'USER_SIGN_IN_FAILURE',

    SET_ERROR: 'USER_SIGN_IN_SET_ERROR',
    REMOVE_ERRORS: 'USER_SIGN_IN_REMOVE_ERRORS',

    USER_SIGN_IN_GENERAL_ERROR: "USER_SIGN_IN_GENERAL_ERROR",
};
